import { _ as _objectWithoutProperties, d as deepMerge } from './deep-merge-c6cfd18c.js';

const _excluded = ["gridSize", "gutterWidth", "outerMargin"];
function createThemeGrid(gridInput, spacing) {
  const {
      gridSize = 12,
      gutterWidth = spacing.xs,
      outerMargin = spacing.md
    } = gridInput,
    rest = _objectWithoutProperties(gridInput, _excluded);
  const grid = deepMerge({
    gridSize,
    gutterWidth,
    outerMargin
  }, rest);
  return grid;
}

export { createThemeGrid };
